var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8352 6.37444C19.5377 3.88318 9.98062 9.40209 7.48891 18.7013C4.9972 28.0004 10.5144 37.5585 19.8119 40.0497C29.1094 42.541 38.6664 37.0221 41.1581 27.7229C43.6498 18.4237 38.1326 8.8657 28.8352 6.37444Z",
    fill: "url(#paint0_linear_6542_77971)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59657 32.6421C4.2937 24.6019 7.16535 13.364 14.5529 8.49156C19.8595 4.99161 27.1255 4.73607 32.5327 7.73817C36.3872 16.5353 32.7053 26.4213 28.1599 29.8621C22.0015 35.4591 18.1362 34.4211 10.9669 34.4599C10.4808 33.8893 10.0188 33.2822 9.59657 32.6421Z",
    fill: "#151955",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6542_77971",
    x1: 17.0301,
    y1: 6.70567,
    x2: 27.4377,
    y2: 39.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.440625,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721875,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.0fd37cf7cfdb3d1e2146ffd4e0179ba7.svg";
export { ForwardRef as ReactComponent };